export default __webpack_public_path__ + "static/media/pictogramBeaconInternational40.fa92549f.svg";